import { Link } from "react-router-dom";
import { ChevronLeft } from "lucide-react";
import { useCommunity } from "@/context/CommunityContext";
import { fileUrl } from "@/lib/api";

export function TopBar({ back, title }) {
  const { community, communities, slug, setSlug } = useCommunity();
  return (
    <header className="sticky top-0 z-30 border-b bg-[rgba(248,245,238,0.9)] backdrop-blur-xl" data-testid="top-bar">
      <div className="mx-auto flex max-w-2xl items-center gap-3 px-4 py-3">
        {back ? (
          <Link to={back} className="btn btn-ghost !p-2" data-testid="back-button" aria-label="zurück">
            <ChevronLeft className="h-5 w-5" />
          </Link>
        ) : (
          <div className="flex h-9 w-9 items-center justify-center overflow-hidden rounded-xl text-xs font-bold text-white" style={{ background: "var(--brand)" }}>
            {community?.logo ? <img src={fileUrl(community.logo)} alt="" className="h-full w-full object-cover" /> : community?.logo_mark || "SR"}
          </div>
        )}
        <div className="min-w-0 flex-1">
          <p className="truncate text-sm font-semibold">{title || community?.short_name || community?.name || "Gemeinde"}</p>
        </div>
        {communities.length > 1 ? (
          <select
            className="rounded-full border bg-white px-3 py-1.5 text-xs"
            value={slug}
            onChange={(e) => setSlug(e.target.value)}
            data-testid="community-switch"
          >
            {communities.map((c) => (
              <option key={c.id} value={c.slug}>
                {c.short_name || c.name}
              </option>
            ))}
          </select>
        ) : null}
      </div>
    </header>
  );
}

export default TopBar;
